
import React from "react";

export default (props) => {
  return (
    <footer style={{
      padding: '12px 16px',
      textAlign: 'center',
      fontSize: '0.75rem',
      color: '#999',
      borderTop: '1px solid #EDEDED',
      marginTop: '24px'
    }}>
      <span>SGR Lotto &copy; {new Date().getFullYear()} — Sistem paw la</span>
    </footer>
  );
};
